<template>
    <div class="schoolProfile">
      <div class="top">
        <div class="topImg1"></div>
        <div class="topImg1Z">
          <h3 style="margin-top: 100px;text-align: center;color: #fff;font-size: 40px;">PARTY BUILDING</h3>
          <p style="width: 2px;background-color: #fff;height: 30px;margin: 10px auto;"></p>
          <p style="text-align: center;color: #fff;"><span class="spanHover" @click="openRouterOne">首页</span>
            &nbsp;&nbsp;>&nbsp;&nbsp;<span
              class="spanHover" @click="openRouter1">学校概况
  
            </span>&nbsp;&nbsp;>&nbsp;&nbsp;<span class="spanHover">学校概况</span></p>
        </div>
        <ul>
          <li class="ulLi" @click="openRouter1">学校概况</li>
          <li @click="openRouter2">教学设施</li>
          <li  @click="openRouter3">学校荣誉</li>
        </ul>
      </div>
      <div class="wrap">
       <div  v-html="getProfile.introduction2">

       </div>
      </div>
    </div>
  </template>
  
  
  <script>
  export default {
    name: "Header",
    data() {
      return {
        getProfile:''
      }
    },
    mounted() {
      this.$axios
            .get("/system/profile/getProfile", {})
            .then(res => {
                if (res.code == 0) {
                this.getProfile = res.data[0]
                } else {
                this.$message.closeAll();
                this.$message.error(res.msg);
                }
            });
    },
    methods: {
      openRouter1() {
        this.$router.push({
          path: "/schoolProfile",
        });
      },
      openRouter2() {
        this.$router.push({
          path: "/teachingFacilities",
        });
      },
      openRouter3() {
        this.$router.push({
          path: "/honor",
        });
      },
      openRouterOne(){
        sessionStorage.setItem("top",0);
        this.$router.push({
          path: "/",
        });
      },
     
    }
  };
  </script>
  
  <style scoped>
  .schoolProfile {
    width: 100%;
  
    .spanHover:hover {
      color: #2589ff;
      cursor: pointer;
    }
  
    .top {
      width: 100%;
      position: relative;
  
      .topImg1 {
        height: 324px;
        background: url(../../assets/introduce.jpg) no-repeat scroll 0 0;
        padding: 0 0 110px 0;
      }
  
      .topImg1Z {
        position: absolute;
        width: 100%;
        height: 324px;
        top: 0;
        left: 0;
        background: rgba(45, 62, 80, 0.8) none repeat scroll 0 0;
      }
  
      ul {
        list-style: none;
  
        margin: 0 auto;
        display: flex;
        text-align: center;
        justify-content: center;
  
        .ulLi {
          color: #0086d1;
        }
  
        li {
          padding: 20px;
        }
  
        li:hover {
          cursor: pointer;
        }
      }
    }
  
    .wrap {
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 30px;
  
      
    }
  }
  </style>